import React from 'react';
import Breadcrumbs from 'components_newui/pageBreadcrumbsMenu/View'
// import ControlButtons from './ControlButtons';
import  ControlButtons  from 'components_newui/control_buttons/View'
import { useHistory } from 'react-router-dom';
import { ChallengeStatusBadge } from './ChallengeStatusBadge';

const ChallengeHeader = ({
  pageHierarchy,
  allButtons,
  name,
  statusStr,
  challengeId,
  statusCol,
  classes,
}) => {
  // console.log("🚀 ~ ChallengeHeader ~ allButtons:", allButtons)
  const history = useHistory();

  const isDisabled = statusStr === 'PROPOSED' || statusStr === 'DRAFT';

  return (
    <>
      <Breadcrumbs crumbs={pageHierarchy} />
      <ChallengeStatusBadge statusStr={statusStr} statusCol={statusCol} classes={classes} />
      <div style={{ display: 'flex', position: 'relative' }}>
        <div className={classes.title}>{name}</div>

        {/* <button
          type="button"
          className={
            isDisabled
              ? `${classes.btnDisabled} ${classes.respondBtn}`
              : classes.respondBtn
          }
          onClick={() => history.push(`/idea/new/${challengeId}`)}
          disabled={isDisabled}
        >
          Respond with idea
        </button> */}
      </div>

      <ControlButtons buttons={allButtons} text="challenge" />

    </>
  );
};

export default ChallengeHeader;
